/** One ordered save stream. Failed patches remain pending until explicitly retried. */
export function createSaveQueue({ save, onState, delay = 400 }) {
  const pending = new Map();
  let timer = null;
  let running = null;
  let failed = false;
  async function drain() {
    onState('saving');
    try {
      while (pending.size) {
        const [key, patch] = pending.entries().next().value;
        pending.delete(key);
        try { await save(key, patch); }
        catch (error) {
          pending.set(key, { ...patch, ...pending.get(key) });
          throw error;
        }
      }
      failed = false;
      onState('saved');
    } catch (error) {
      clearTimeout(timer);
      timer = null;
      failed = true;
      onState('error');
      throw error;
    }
  }
  function flush() {
    clearTimeout(timer);
    timer = null;
    if (running) return running;
    if (!pending.size) return Promise.resolve();
    running = drain().finally(() => { running = null; });
    return running;
  }
  return {
    enqueue(key, patch) {
      pending.set(key, { ...pending.get(key), ...patch });
      clearTimeout(timer);
      onState(failed ? 'error' : 'saving');
      if (!failed) timer = setTimeout(() => { flush().catch(() => {}); }, delay);
    },
    flush,
    hasPending: () => pending.size > 0 || running !== null,
  };
}
